const Pact = require("../../entities/Pact");
const {Age}  = require("../Constants");
const PactNames = require("../Names/PactNames");


class InternationalTourism extends Pact {
    constructor() {
        super(
            Age.Age3,
            PactNames.InternationalTourism,
            "Each civilization produces an extra 1 culture per round for every wonder owned by the other civilization.",
            {}
        )
    }
}

module.exports = InternationalTourism;